import {useState,useEffect} from 'react'
import {envAwarePost} from '../util/util'
import {useSelector} from 'react-redux'

/**
 * Since the business logic surrounding shared/non-shared
 * clients is all handled on the back end use this api 
 * call to fetch the clients to which a certain event
 * is allowed to be copied
 */
const useUsersForEventCopy = (event_type,event_id)=>{
	const [status,setStatus] = useState('pending')
	const [users,setUsers] = useState([])
	const [warning,setWarning] = useState("")

	useEffect(()=>{
		setStatus('pending')
		setUsers([])
		setWarning('')
		envAwarePost('api/events/api/',{
			action:'getUsersForEventCopy',
			event_type,
			event_id,
		}).then(res=>{
			setUsers(res.data.users)
			setWarning(res.data.warning_message)
			setStatus('idle')
		})
	},[event_type,event_id])
	

	return {status,users,warning}
}

export default useUsersForEventCopy